import React from 'react';
import { SectionTitle } from '../ui/CommonComponents';
import { TimelineItem } from '../ui/TimelineItem';
import RevealOnScroll from '../../hooks/useRevealOnScroll';
import { experiences } from '../../data/portfolioData';
import { useTranslation } from '../../hooks/useTranslation';

export const ExperienceSection = ({ expandedExperience, setExpandedExperience }) => {
    const { t } = useTranslation();

    return (
        <section id="experience" className="py-20 px-6 bg-[#0d0d0d]">
            <div className="container mx-auto">
                <RevealOnScroll>
                    <SectionTitle title={t('experienceTitle')} subtitle={t('experienceSubtitle')} />
                </RevealOnScroll>

                <div className="max-w-4xl mx-auto">
                    {experiences.map((exp, index) => (
                        <RevealOnScroll key={index} delay={index * 100}>
                            <TimelineItem
                                data={exp}
                                isOpen={expandedExperience === index}
                                onClick={() => setExpandedExperience(expandedExperience === index ? null : index)}
                                isLast={index === experiences.length - 1}
                            />
                        </RevealOnScroll>
                    ))}
                </div>
            </div>
        </section>
    );
};